import colors from 'vuetify/es5/util/colors'

var defaultThemes = {
  light: {
    primary: '#1A1889',
    secondary: '#20252A',
    accent: '#FFFFFF',
    stepper: '#2926DB',
    button: '#15252B',
    ligthText: '#475467',
    ligthText2: '#484C4F',
    boldText: '#1E1E1E',
    textFooter: '#FFFFFF',
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber,
    black1: '#231F20',
    success2: '#96F3C6',
    backgroundImageTextColor: '#000000'
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

var theme = {
  dark: false,
  options: {
    customProperties: true,
    dense: false,
  },
}

const defaultEnv = 'dbscred';

theme.baseAmbienteUrl = `/assets/imgs/${defaultEnv}/`;

require(`@/assets/imgs/${defaultEnv}/logo.svg`);
theme.logo = `/assets/imgs/${defaultEnv}/logo.svg`;

require(`@/assets/imgs/${defaultEnv}/sessao-expirada.svg`);
theme.sessaoExpirada = `/assets/imgs/${defaultEnv}/sessao-expirada.svg`;

require(`@/assets/imgs/${defaultEnv}/not-found-icon.svg`);
theme.notFoundIcon = `/assets/imgs/${defaultEnv}/not-found-icon.svg`;

require(`@/assets/imgs/${defaultEnv}/email-icon.svg`);
theme.emailIcon = `/assets/imgs/${defaultEnv}/email-icon.svg`;

require(`@/assets/imgs/${defaultEnv}/continueModalImg.svg`);
theme.continueModalImg = `/assets/imgs/${defaultEnv}/continueModalImg.svg`;

require(`@/assets/imgs/${defaultEnv}/passo1.svg`);
theme.passo1 = `/assets/imgs/${defaultEnv}/passo1.svg`;

require(`@/assets/imgs/${defaultEnv}/passo2.svg`);
theme.passo2 = `/assets/imgs/${defaultEnv}/passo2.svg`;

require(`@/assets/imgs/${defaultEnv}/passo3.svg`);
theme.passo3 = `/assets/imgs/${defaultEnv}/passo3.svg`;

require(`@/assets/imgs/${defaultEnv}/passo4.svg`);
theme.passo4 = `/assets/imgs/${defaultEnv}/passo4.svg`;

const favicon = document.getElementById('custom-favicon')
favicon.setAttribute('href', `/assets/imgs/${defaultEnv}/favicon.svg`)

var currentThemes = { ...defaultThemes };

switch (window.env.VUE_APP_AMBIENTE) {
  case 'flowmodde': {
    const primary = '#0E2443';
    const secondary = '#42CB85';

    currentThemes.light.primary = primary
    currentThemes.light.secondary = secondary
    currentThemes.light.stepper = primary
    // currentThemes.light.backgroundImageTextColor = '#ffffff'
    break
  }
  case 'sifra_sa': {
    const primary = '#00244D';
    const secondary = '#3A66FA';

    currentThemes.light.primary = primary
    currentThemes.light.secondary = secondary
    currentThemes.light.stepper = primary
    break
  }
}

try {
  if (localStorage.ambiente) {
    const ambienteAtual = localStorage.ambiente;
    // require('@/assets/imgs/' + ambienteAtual + '/background.svg')
    // theme.background = '/assets/imgs/' + ambienteAtual + '/background.svg'

    theme.background = undefined;

    theme.baseAmbienteUrl = `/assets/imgs/${ambienteAtual}/`;

    require('@/assets/imgs/' + ambienteAtual + '/logo.svg')
    theme.logo = '/assets/imgs/' + ambienteAtual + '/logo.svg'

    require('@/assets/imgs/' + ambienteAtual + '/sessao-expirada.svg')
    theme.sessaoExpirada = '/assets/imgs/' + ambienteAtual + '/sessao-expirada.svg'

    require('@/assets/imgs/' + ambienteAtual + '/not-found-icon.svg')
    theme.notFoundIcon = '/assets/imgs/' + ambienteAtual + '/not-found-icon.svg'

    require('@/assets/imgs/' + ambienteAtual + '/email-icon.svg')
    theme.emailIcon = '/assets/imgs/' + ambienteAtual + '/email-icon.svg'

    require('@/assets/imgs/' + ambienteAtual + '/continueModalImg.svg')
    theme.continueModalImg = '/assets/imgs/' + ambienteAtual + '/continueModalImg.svg'

    require('@/assets/imgs/' + ambienteAtual + '/passo1.svg')
    theme.passo1 = '/assets/imgs/' + ambienteAtual + '/passo1.svg'

    require('@/assets/imgs/' + ambienteAtual + '/passo2.svg')
    theme.passo2 = '/assets/imgs/' + ambienteAtual + '/passo2.svg'

    require('@/assets/imgs/' + ambienteAtual + '/passo3.svg')
    theme.passo3 = '/assets/imgs/' + ambienteAtual + '/passo3.svg'

    require('@/assets/imgs/' + ambienteAtual + '/passo4.svg')
    theme.passo4 = '/assets/imgs/' + ambienteAtual + '/passo4.svg'

    favicon.setAttribute('href', '/assets/imgs/' + ambienteAtual + '/favicon.svg')
  }
} catch (error) {
  console.error('Falha ao iniciar o tema: ', error)
}

export default {
  ...theme,
  themes: currentThemes
}
